import React from 'react'
import { PredictedTrafficBadge } from 'components/PredictedTrafficBadge/PredictedTrafficBadge'

const values = ['Very High', 'High', 'Average', 'Low', null] as const

export function PredictedTrafficBadgeMock(): React.ReactElement {
  return (
    <div className="flex flex-wrap gap-2 items-center">
      {values.map((v) => (
        <PredictedTrafficBadge key={v ?? 'null'} value={v ?? null} />
      ))}
    </div>
  )
}
